import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/cnd/v1/agendamento`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCNDAgenda(empresa_cnpj) {
  return search(
    `${process.env.REACT_APP_URL_API_ERP}/cnd/v1/agendas?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function createCNDAgenda(body = {}, empresa_cnpj) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function updateCNDAgenda(body = {}, id, empresa_cnpj) {
  return search(
    `${path}/update/${id}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function deleteCNDAgenda(id, empresa_cnpj) {
  return search(
    `${path}/delete/${id}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers
  );
}
